import React from 'react';
import { Icon } from 'app/shared/ui';
import { Box, Flex } from '@rebass/grid';

import { ListSt, ListItemSt } from './ListItems.css';
import { IListItems } from './ListItems.types';

export const ListItems = ({
  icons = 'check',
  color = 'inherit',
  iconSize = [16, 16, 20, 24],
  direction = 'column',
  children,
}: IListItems): JSX.Element => {
  let keyCount = 0;

  return (
    <ListSt flexDirection={direction}>
      {React.Children.map(children, (child, index) => {
        keyCount += 1;
        const icon = Array.isArray(icons) ? icons[index] : icons;

        return (
          <ListItemSt key={`list-item-${keyCount}`}>
            <Flex pr={[8, 8, 16]} alignSelf="center">
              <Icon icon={icon} fontSize={iconSize} color={color} />
            </Flex>

            <Box>{child}</Box>
          </ListItemSt>
        );
      })}
    </ListSt>
  );
};
